import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Truck, ArrowLeft } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm">
        <div className="flex items-center gap-2.5 mb-8 justify-center">
          <div className="p-2 rounded-md bg-blue-600 text-slate-950"><Truck size={24} weight="fill" /></div>
          <span className="font-heading font-black text-xl text-slate-900">FreightCommand</span>
        </div>
        <h1 className="font-heading font-black text-2xl text-slate-900">Set a new password</h1>
        <p className="text-sm text-slate-500 mt-2 mb-6">Choose a strong password for your account.</p>
        <form onSubmit={submit} className="space-y-4">
          <Input data-testid="reset-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="New password" required minLength={6}
            className="bg-white border-slate-300 focus:border-blue-500 focus-visible:ring-blue-500 h-11" />
          {error && <p className="text-sm text-red-400">{error}</p>}
          <Button data-testid="reset-submit" type="submit" disabled={loading || !token}
            className="w-full h-11 bg-blue-600 text-white hover:bg-blue-700 font-semibold">
            {loading ? "Updating…" : "Update password"}
          </Button>
          {!token && <p className="text-sm text-red-400">Missing reset token. Use the link from your email.</p>}
        </form>
        <div className="mt-6 text-center">
          <Link to="/login" className="text-sm text-slate-500 hover:text-blue-600 inline-flex items-center gap-1.5">
            <ArrowLeft size={14} /> Back to sign in
          </Link>
        </div>
      </div>
    </div>
  );
}
